import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import { Pressable } from '@atlaskit/primitives/compiled';
import { IconButton } from '@atlaskit/button/new';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

type DraftCommentBoxProps = {
	testId?: string;
	expandPageCommentEditorHandler: () => void;
};

const styles = cssMap({
	draftComment: {
		width: '100%',
		height: '36px',
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
		padding: token('space.100'),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		color: token('color.text.subtlest'),
		backgroundColor: token('color.background.input'),
	},
});

const i18n = defineMessages({
	unsavedDraftComment: {
		id: 'object-comments.draft-comment-box.text',
		defaultMessage: '• Comment in progress - select to continue',
		description: 'Text message for unsaved draft page comment',
	},
	expandPageCommentIconLabel: {
		id: 'object-comments.draft-comment-box.expand-editor',
		defaultMessage: 'Expand page comment editor',
		description: 'Label for page comment draft box icon to expand',
	},
});

export const DraftCommentBox: React.FC<DraftCommentBoxProps> = ({
	testId = 'draft-comment-box',
	expandPageCommentEditorHandler,
}) => {
	const { formatMessage } = useIntl();

	return (
		<Pressable xcss={styles.draftComment} testId={testId} onClick={expandPageCommentEditorHandler}>
			{formatMessage(i18n.unsavedDraftComment)}
			<IconButton
				onClick={expandPageCommentEditorHandler}
				appearance="subtle"
				icon={ChevronUpIcon}
				label={formatMessage(i18n.expandPageCommentIconLabel)}
			/>
		</Pressable>
	);
};
